<div class="flex flex-row gap-2">
  <button matButton="filled" color="primary" [disabled]="loading" (click)="downloadReconciliationFile()">
    Download reconciliation file
  </button>
  <button matButton="filled" color="primary" [disabled]="loading" (click)="downloadPaymentsBatch()">
    Download payments batch
  </button>
  <button matButton="filled" color="primary" [disabled]="loading || disableMarkAsSent" (click)="markAsSent()">
    Mark as sent
  </button>
</div>
